import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import { decryptAESData } from "../utils/types";

interface CheckPermissionProps {
  roleCode: string | string[];
  children: ReactNode;
  path?: any;
}

const CheckPermission = ({
  roleCode,
  children,
  path,
}: CheckPermissionProps): JSX.Element => {

  const data: any = !!sessionStorage.getItem("data")
    ? JSON.parse(sessionStorage.getItem("data") as any)
    : null;

  const location = useLocation();

  const userRole = decryptAESData(data?.roles)?.role_code;

  const allowedRoles = Array.isArray(roleCode) ? roleCode : [roleCode];

  if (
    allowedRoles.includes(userRole) &&
    (userRole == "administrator" ||
      userRole == "interviewer" ||
      userRole == "candidate" ||
      userRole == "bidder")
  ) {
    return <>{children}</>;
  } else if (
    userRole !== "administrator" &&
    userRole !== "interviewer" &&
    userRole !== "candidate" &&
    userRole !== "bidder"
  ) {
    return location?.pathname.includes(path) ? (
      <Navigate to="/admin/dashboard" />
    ) : (
      <>{children}</>
    );
  }

  return <Navigate to="/admin/dashboard" />;
};

export default CheckPermission;
